import React from 'react'

function ErrorIcon(): JSX.Element {
  return (
    <svg
      width="30"
      height="26"
      viewBox="0 0 30 26"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M30 25.9091L15 0L0 25.9091H30ZM16.3636 21.8182H13.6363V19.0909H16.3636V21.8182ZM13.6363 16.3637H16.3636V10.9091H13.6363V16.3637Z"
        fill="#E3534F"
      />
    </svg>
  )
}

export default ErrorIcon
